import React, { FC } from 'react';
import styled from '@emotion/styled';
import {
    BodyTextMedium,
    DeprecatedButtonGroup,
    HeadingText60,
    pxToRem,
} from '@modernhealth/vital-components';
import delivery from '../assets/marginalia-delivery.svg';
import send from '../assets/send.svg';
import { EligibilityStatus } from 'src/modules/dependents/pages/InviteDependentPage';
import { Trans, useTranslation } from 'react-i18next';

export interface RequestSentProps {
    onInviteAnother: (buttonCopy: string) => void;
    onReturnHome: (buttonCopy: string) => void;
    eligibilityStatus: EligibilityStatus;
    dependentInfo: { email: string; fullName: string };
}

export const RequestSent: FC<RequestSentProps> = ({
    onInviteAnother,
    onReturnHome,
    eligibilityStatus,
    dependentInfo,
}) => {
    const { t } = useTranslation();
    const isEligibleToJoin = eligibilityStatus === 'join';
    return (
        <Container>
            <Image
                src={isEligibleToJoin ? send : delivery}
                alt=""
                // sendSVG itself has a bottom padding
                style={{ marginBottom: isEligibleToJoin ? pxToRem(40) : 0 }}
            />
            <HeadingText60 centered marginBottom={16}>
                {t(`dependents:request_sent.title.${eligibilityStatus}`)}
            </HeadingText60>
            <BodyTextMedium centered fontColor="gray65">
                <Trans
                    t={t}
                    i18nKey={`dependents:request_sent.description.${eligibilityStatus}`}
                    values={dependentInfo}
                    components={{
                        strong: <b />,
                    }}
                />
            </BodyTextMedium>
            <DeprecatedButtonGroup
                firstButtonText={t('dependents:common.add_another_dependent')}
                onFirstButtonClick={() =>
                    onInviteAnother(t('dependents:common.add_another_dependent'))
                }
                secondButtonText={t('dependents:common.return_home')}
                onSecondButtonClick={() => onReturnHome(t('dependents:common.return_home'))}
                marginTop={34}
            />
        </Container>
    );
};

const Image = styled.img({
    width: 260,
});
const Container = styled.div({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: pxToRem(500),
});
